<footer>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <p class="clg px12">Brought to you by</p>
        <p class="px18">Speakers and Contributors of DevFest India, 2020</p>
      </div>
    </div>
  </div>
</footer>
